import styled from "styled-components";

const Title = styled.h2`
  font-size: 0.83em;
`;

export const Nav = styled.div`
  margin: 0 auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  width: 440px;
  max-width: 390px;
  padding: 0 0.8rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -moz-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
`;

export const IconRestart = styled.img`
  height: 25px;
  width: 25px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  pointer-events: none;
`;

export const IconQuestion = styled.img`
  height: 25px;
  width: 25px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  pointer-events: none;
`;

export const Container = styled.div`
  > :first-child {
    margin-right: 5px;
  }
`;

export const Modal = styled.div`
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
`;

export const ModalContent = styled.div`
  background-color: #dbdee1;
  margin: 48% auto;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  max-width: 370px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.2) 0 2px 10px 0;
  -moz-box-shadow: rgba(0, 0, 0, 0.2) 0 2px 10px 0;
  box-shadow: rgba(0, 0, 0, 0.2) 0 2px 10px 0;
`;

export const Close = styled.img`
  width: 25px;
  height: 25px;
  float: right;
  position: relative;
  top: -14px;
  left: 18px;
  cursor: pointer;
`;

export const Message = styled.div`
  font-weight: 500;
  font-size: 0.9rem;
  color: #36393f;
  padding: 12px;
`;

export const BlockInfo = styled.div`
  background: #006ef1;
  color: #fff;
  padding: 10px 0;
  text-align: center;
  -webkit-border-top-left-radius: 19px;
  -moz-border-radius-topleft: 19px;
  border-top-left-radius: 19px;
  -webkit-border-top-right-radius: 19px;
  -moz-border-radius-topright: 19px;
  border-top-right-radius: 19px;
`;

export const ButtonBlock = styled.div`
  margin: 0 0 12px 12px;
`;

export const BlockContent = styled.div`
  margin: 20px 0 20px 12px;
`;

export default Title;
